<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.location.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/location"><span>{{$t('tlt.location')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('location')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.name") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="locNameFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.type") }} :
                                    </label>
                                    <select class="form-control" v-model="locTypeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="E">{{ $t("lbl.location.enterprise") }}</option>
                                        <option value="S">{{ $t("lbl.location.site") }}</option>  
                                        <option value="A">{{ $t("lbl.location.area") }}</option>                                        
                                        <option value="W">{{ $t("lbl.location.workCenter") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.active") }}:
                                    </label>
                                    <select class="form-control"  v-model="activeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                                <div class="col-lg-2 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('location')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('location')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="locationResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <div class="bs-component">
                                <div class="btn-group float-left">
                                    <a href="#" data-toggle="modal" class="btn btn-outline-primary btn-sm"
                                    v-on:click="MMFEdit('location')">
                                        <i title="lbl.edit" class="fa fa-pencil-alt"></i>
                                    </a>
                                    <a href="#Detail" data-toggle="modal" class="btn btn-outline-primary btn-sm"
                                    v-on:click="MMFEdit('location')">
                                        <i title="lbl.edit" class="fa fa-eye"></i>
                                    </a>
                                    <a href="#" data-toggle="modal" class="btn btn-outline-primary btn-sm"
                                    v-on:click="MMFDelete('location')">
                                        <i title="lbl.basic.delete" class="fa fa-trash"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="float-lg-right">
                                    <a href="#" class="btn btn-outline-primary" title="export">
                                        <i class="fa fa-file-export"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="clearfix">&nbsp;</div>
                            <b-table
                                striped
                                hover
                                responsive
                                caption-top
                                :items="rows"
                                :fields="tableColumns">

                                <template slot="table-caption">
                                    <b-form-checkbox @click.native.stop @change="MMFselectAllRows()">
                                        Select all
                                    </b-form-checkbox>
                                </template>
                                <template slot="state" slot-scope="data">
                                    <b-form-checkbox @click.native.stop @change="MMFselectRow({item: data.item, entity:'location'})">
                                    </b-form-checkbox>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/master/Location";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'location/getField',
    mutationType: 'location/updateField',
  });

export default {
  name: "locationList",
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.location.rows,
            tableColumns: gridFields
        })
  },
  methods: {
    //...mapActions("location", ["loadLocations"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  }
};
</script>
